import React from 'react';
import KPISet from '../components/elletre/KPISet';
import List from './List';

const dataProviderName = 'bis/viewer';

const Elletre = () => {
    const now = new Date();
    const startOfYear = new Date(`${now.getFullYear()}-01-01`);
    const defaultFilters = {
        items: []
    };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <List filters={defaultFilters} />
    </>

}

export default Elletre;


